import React, { useState, useEffect, useRef } from 'react';

const TypewriterChapterMark = ({ text }) => {
  const [displayedText, setDisplayedText] = useState('');
  const [isVisible, setIsVisible] = useState(false);
  const [showCursor, setShowCursor] = useState(true);
  const elementRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          setShowCursor(true); // Reset cursor visibility when entering view
        } else {
          setIsVisible(false);
          setDisplayedText(''); // Reset text when out of view to re-type
        }
      },
      { 
        threshold: 0.1,
        rootMargin: "0px 0px -20% 0px"
      }
    );

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    let intervalId;
    let timeoutId;

    if (isVisible) {
      let index = 0;
      intervalId = setInterval(() => {
        if (index < text.length) {
            setDisplayedText(text.slice(0, index + 1));
            index++;
        } else {
            clearInterval(intervalId);
            // Hide cursor after 3 seconds (approx 3 blinks)
            timeoutId = setTimeout(() => {
              setShowCursor(false);
            }, 3000);
        }
      }, 100); // Typing speed
    }
    
    return () => {
      clearInterval(intervalId);
      clearTimeout(timeoutId);
    };
  }, [isVisible, text]);

  return (
    <div className="chapter-mark" ref={elementRef}>
      {/* Ghost element to reserve full width */}
      <span style={{ visibility: 'hidden', whiteSpace: 'nowrap' }}>{text}|</span>
      
      {/* Actual content positioned absolute right to keep cursor fixed */}
      <div style={{ 
        position: 'absolute', 
        top: 0, 
        right: 0, 
        bottom: 0,
        display: 'flex', 
        alignItems: 'center',
        whiteSpace: 'nowrap'
      }}>
        <span>{displayedText}</span>
        <span className="blinking-cursor" style={{ visibility: showCursor ? 'visible' : 'hidden' }}>|</span>
      </div>
    </div>
  );
};

export default TypewriterChapterMark;
